import * as LocalStorageUtils from "./localStorageUtils";
import * as AlertUtils from "./alertUtils";

function decodeJwt(token) {
  try {
    const parts = token.split(".");
    if (parts.length !== 3) return null;
    const payload = JSON.parse(atob(parts[1]));
    return { payload };
  } catch {
    return null;
  }
}

export const TokenValidation = () => {
  const token = LocalStorageUtils.GetAuthToken();
  if (token) {
    var decodedToken = decodeJwt(token);
    if (!decodedToken) {
      localStorage.clear();
      return false;
    }
    const expiryDate = decodedToken.payload.exp * 1000;
    if (expiryDate < Date.now()) {
      localStorage.clear();
      AlertUtils.CustomSuccessAlert("Token Expired ! Please Login Again");
      window.location.reload();
      return false;
    } else {
      return true;
    }
  } else {
    return false;
  }
};

export const getLoginAccountID = () => {
  const token = LocalStorageUtils.GetAuthToken();
  if (token) {
    var decodedToken = decodeJwt(token);
    return decodedToken?.payload?.userId || false;
  } else {
    return false;
  }
};
